
import React, { useEffect } from "react";
import { IconButton, Button, TextField } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { GetCart, Increment, Decrement, Remove, GetCount, GetTotal } from './CartHandler.js'
import { decompressToBase64, formatter } from "../../utils/common.js";
import "./Cart.css"
import CheckoutModal from './CheckoutModal.js'
import axios from "axios";

const apiUrl = process.env.REACT_APP_BASEURL;


const Cart = (props) => {
    const [cart, setCart] = useState(GetCart());
    const [isOpen, setIsOpen] = useState(false);
    const [productCount, setProductCount] = useState(GetCount);
    const [totalPrice, setTotalPrice] = useState(0);
    const [itemsCount, setItemsCount] = useState(0);
    const navigate = useNavigate();
    const [taxes, setTaxes] = useState(0);
    const [orderTotal, setOrdersTotal] = useState(0);
    const [totalCount, setTotalCount] = useState(GetTotal());
    const [shipping, setShipping] = useState(0);
    const headers = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + props.token.token
    };

    useEffect(() => {
        setProductCount(GetCount());
      }, []);

    function handleIncrementClick(item) {
        Increment(item.ItemNumber, cart);
        setCart(GetCart);
    }

    function handleDecrementClick(item) {
        Decrement(item.ItemNumber, cart);
        setCart(GetCart);
    }

    function handleRemoveClick(item) {
        Remove(item.ItemNumber, cart);
        setCart(GetCart);
        props.setCartCount(GetCount())
    }

    function onRequestClose() {
        setIsOpen(false);
        setCart(GetCart);
        navigate('/myCart');
    }

    function handleClick() {
        setIsOpen(true)
    }

    const continueShopping = () => {
        navigate("/CategorySearchResults");

    }

    
    //BELOW Was a post method in the original project. I changed the post top get both this call and on the API.
    const getShippingTotal=()=>{
        try {
            axios.put(apiUrl + `/api/ShippingRate/GetUpsGroundRate`,JSON.stringify(GetCart()),{
                headers: headers

          })
              .then((response) => {
                // console.log("UPS GROUND RATE TOTALS BLOCK: ", response.data);
                  setShipping(response.data);
           
               })
              .catch((error) => {
                console.log(error);
              });
          } catch (error) {
            console.log(error);
          }
    }

    //below was a PUT in the original code. I changed this method to get in both the code and the API
    const getCartTax=()=>{
        try {
            axios.put(apiUrl + `/api/Items/GetCartTax`,JSON.stringify(GetCart()) ,{
                headers: headers
                // body: JSON.stringify(GetCart())
          })
              .then((response) => {
                // console.log("TotalsBlock GetCartTaxes Data: ", response.data);
               
                  setTaxes(response.data);
           
               })
              .catch((error) => {
                console.log(error);
              });
          } catch (error) {
            console.log(error);
          }
    }
    
    const setOrderTotal = () =>{
        setOrdersTotal(productCount+props.shipping+taxes);
    }

    useEffect(() => {
        // console.log("Token on Totals Block",props.token);
        getShippingTotal();
        getCartTax();
        setOrderTotal();
    }, []);



    useEffect(() => {
        let itemCount = 0; // Initialize itemCount to 0
      
        const total = cart.reduce((acc, item) => {
          let itemTotalCount = 0;
      
          if (item.Quantity && productCount) {
            itemTotalCount = productCount + item.Quantity;
          } else if (item.Quantity) {
            itemTotalCount = item.Quantity;
          }
      
          // Accumulate the total item count
          itemCount += itemTotalCount;
          itemCount = itemCount - productCount;
      
        //   console.log(`Quantity: ${item.Quantity}`);
        //   console.log(`Price: ${parseFloat(item.Price)}`);
          
          // Return accumulated total price
          return acc + parseFloat(item.Price) * item.Quantity ;
        }, 0);
      
        // Set the total item count and price in state
        setItemsCount(itemCount);
        setTotalPrice(total);
      }, [cart, productCount]);
      
      



    return (
        <div className="container " id="cart-container">

            {<div className="lg:grid grid-cols-3 lg:px-16 relative ">
                <div className="lg:col-span-2 lg:px-3 bg-white">
                    <div className=" space-y-3 ">
                        {cart.map((item) => (
                            <div className="p-3 mt-5 shadow-lg border rounded-md">
                                <div className="flex items-center" key={item.ItemNumber}>
                                    <div className="w-[15rem] h-[5rem] lg:w-[12rem] lg:h-[9rem] ">
                                        {item.Images && item.Images[0] && item.Images[0].compressedImageData ? (
                                            <img
                                                className="w-full h-full object-top"
                                                src={"data:image/png;base64," + decompressToBase64(item.Images[0].compressedImageData)}
                                                alt="image"
                                            />
                                        ) : null}

                                    </div>
                                    <div className="ml-5 space-y-1">
                                        <p className="font-semibold">{item.ItemDescription}</p>
                                        <p className="opacity-70">Item #: {item.ItemNumber}</p>

                                        <div className="flex space-x-2 items-center pt-3">
                                            <p className="opacity-50 line-through">{formatter.format(item.Price)}</p>
                                            <p className="font-semibold text-lg">
                                                {formatter.format(item.Price * 0.9)}
                                            </p>
                                            <p className="text-green-600 font-semibold">
                                                {"10"}% off
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="lg:flex items-center lg:space-x-10 pt-2">
                                    <div className="flex items-center space-x-2 ">
                                        <IconButton onClick={() => handleDecrementClick(item)} disabled={item?.Quantity <= 1} color="primary" aria-label="add an alarm">
                                            <RemoveCircleOutlineIcon />
                                        </IconButton>
                                        <span className="py-1 px-7 border rounded-sm">{item.Quantity}</span>
                                        <IconButton onClick={() => handleIncrementClick(item)} color="primary" aria-label="add an alarm">
                                            <AddCircleOutlineIcon />
                                        </IconButton>
                                    </div>
                                    <div className="flex text-sm lg:text-base mt-2 lg:mt-0 lg:pl-3">

                                        <Button onClick={() => handleRemoveClick(item)} variant="text">
                                            Remove{" "}
                                        </Button>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className=" sticky top-0 h-[100vh] mt-5 lg:mt-0 ">
                    <div className="border p-5 bg-white shadow-lg rounded-md  details-con checkout-box">
                        
                        <p className="font-bold opacity-60 pb-4">Order Summary</p>
                        <hr />

                        <div className="space-y-3 font-semibold">
                            <div className="flex justify-between pt-3 text-black">
                                <span>subtotal ({itemsCount} {itemsCount > 1 ? "items" : "item"})</span>
                                <span>{formatter.format(totalPrice)}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>Discount</span>
                                <span className="text-green-700">${"0"}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>Shipping</span>
                                <span className="text-green-700">{shipping}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>Taxes</span>
                                <span className="text-green-700">{formatter.format(taxes)}</span>
                            </div>
                            <hr />
                            <div className="flex justify-between font-bold text-lg">
                                <span>Total</span>
                                <span className="text-green-700">{formatter.format(totalPrice + shipping + taxes)}</span>
                            </div>
                        </div>

                        <Button
                            className="checkout-btn"
                            onClick={() => handleClick()}
                            variant="contained"
                            type="submit"
                            sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "8rem" }}
                        >
                            Check Out
                        </Button>
                        <Button
                            className="continue-sh"
                            onClick={continueShopping}
                            variant="contained"
                            sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "13rem", marginLeft: "1rem" }}
                        >
                            Continue Shopping
                        </Button>
                
                    </div>
                </div>
            </div>}
            {isOpen ? <CheckoutModal token={props.token} onRequestClose={onRequestClose}
                cartCount={props.cartCount} setCartCount={props.setCartCount} /> : null}
        </div>
    );
};

export default Cart;
